module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/ja_kyushu-972570a6e0ab7ee7871540c4168d1e03.jpg";